export const countries = [
  {
    countryName: 'Albania',
    countryShortCode: 'AL'
  },
  {
    countryName: 'Andorra',
    countryShortCode: 'AD'
  },
  {
    countryName: 'Armenia',
    countryShortCode: 'AM'
  },
  {
    countryName: 'Australia',
    countryShortCode: 'AU'
  },
  {
    countryName: 'Austria',
    countryShortCode: 'AT'
  },
  {
    countryName: 'Belarus',
    countryShortCode: 'BY'
  },
  {
    countryName: 'Belgium',
    countryShortCode: 'BE'
  },
  {
    countryName: 'Bosnia and Herzegovina',
    countryShortCode: 'BA'
  },
  {
    countryName: 'Bulgaria',
    countryShortCode: 'BG'
  },
  {
    countryName: 'Canada',
    countryShortCode: 'CA'
  },
  {
    countryName: 'Chile',
    countryShortCode: 'CL'
  },
  {
    countryName: 'China',
    countryShortCode: 'CN'
  },
  {
    countryName: 'Croatia',
    countryShortCode: 'HR'
  },
  {
    countryName: 'Cyprus',
    countryShortCode: 'CY'
  },
  {
    countryName: 'Czech Republic',
    countryShortCode: 'CZ'
  },
  {
    countryName: 'Denmark',
    countryShortCode: 'DK'
  },
  {
    countryName: 'Egypt',
    countryShortCode: 'EG'
  },
  {
    countryName: 'Estonia',
    countryShortCode: 'EE'
  },
  {
    countryName: 'Finland',
    countryShortCode: 'FI'
  },
  {
    countryName: 'France',
    countryShortCode: 'FR'
  },
  {
    countryName: 'Georgia',
    countryShortCode: 'GE'
  },
  {
    countryName: 'Germany',
    countryShortCode: 'DE'
  },
  {
    countryName: 'Ghana',
    countryShortCode: 'GH'
  },
  {
    countryName: 'Greece',
    countryShortCode: 'GR'
  },
  {
    countryName: 'Hong Kong',
    countryShortCode: 'HK'
  },
  {
    countryName: 'Hungary',
    countryShortCode: 'HU'
  },
  {
    countryName: 'Iceland',
    countryShortCode: 'IS'
  },
  {
    countryName: 'India',
    countryShortCode: 'IN'
  },
  {
    countryName: 'Indonesia',
    countryShortCode: 'ID'
  },
  {
    countryName: 'Iran, Islamic Republic of',
    countryShortCode: 'IR'
  },
  {
    countryName: 'Ireland',
    countryShortCode: 'IE'
  },
  {
    countryName: 'Israel',
    countryShortCode: 'IL'
  },
  {
    countryName: 'Italy',
    countryShortCode: 'IT'
  },
  {
    countryName: 'Japan',
    countryShortCode: 'JP'
  },
  {
    countryName: 'Jordan',
    countryShortCode: 'JO'
  },
  {
    countryName: 'Kenya',
    countryShortCode: 'KE'
  },
  {
    countryName: 'Korea, Republic of',
    countryShortCode: 'KR'
  },
  {
    countryName: 'Kuwait',
    countryShortCode: 'KW'
  },
  {
    countryName: 'Latvia',
    countryShortCode: 'LV'
  },
  {
    countryName: 'Lebanon',
    countryShortCode: 'LB'
  },
  {
    countryName: 'Liechtenstein',
    countryShortCode: 'LI'
  },
  {
    countryName: 'Lithuania',
    countryShortCode: 'LT'
  },
  {
    countryName: 'Luxembourg',
    countryShortCode: 'LU'
  },
  {
    countryName: 'Malaysia',
    countryShortCode: 'MY'
  },
  {
    countryName: 'Malta',
    countryShortCode: 'MT'
  },
  {
    countryName: 'Mexico',
    countryShortCode: 'MX'
  },
  {
    countryName: 'Moldova',
    countryShortCode: 'MD'
  },
  {
    countryName: 'Montenegro',
    countryShortCode: 'ME'
  },
  {
    countryName: 'Netherlands',
    countryShortCode: 'NL'
  },
  {
    countryName: 'Norway',
    countryShortCode: 'NO'
  },
  {
    countryName: 'Pakistan',
    countryShortCode: 'PK'
  },
  {
    countryName: 'Poland',
    countryShortCode: 'PL'
  },
  {
    countryName: 'Portugal',
    countryShortCode: 'PT'
  },
  {
    countryName: 'Qatar',
    countryShortCode: 'QA'
  },
  {
    countryName: 'Romania',
    countryShortCode: 'RO'
  },
  {
    countryName: 'San Marino',
    countryShortCode: 'SM'
  },
  {
    countryName: 'Saudi Arabia',
    countryShortCode: 'SA'
  },
  {
    countryName: 'Serbia',
    countryShortCode: 'RS'
  },
  {
    countryName: 'Slovakia',
    countryShortCode: 'SK'
  },
  {
    countryName: 'Slovenia',
    countryShortCode: 'SI'
  },
  {
    countryName: 'South Africa',
    countryShortCode: 'ZA'
  },
  {
    countryName: 'Spain',
    countryShortCode: 'ES'
  },
  {
    countryName: 'Sweden',
    countryShortCode: 'SE'
  },
  {
    countryName: 'Switzerland',
    countryShortCode: 'CH'
  },
  {
    countryName: 'Turkey',
    countryShortCode: 'TR'
  },
  {
    countryName: 'Ukraine',
    countryShortCode: 'UA'
  },
  {
    countryName: 'United Kingdom',
    countryShortCode: 'GB'
  },
  {
    countryName: 'United Arab Emirates',
    countryShortCode: 'AE'
  },
  {
    countryName: 'United States',
    countryShortCode: 'US'
  },
  {
    countryName: 'Vietnam',
    countryShortCode: 'VN'
  }
]
